import Ymc from '@/views/ymc/Ymc.vue'
import Ychuan from '@/views/ymc/Ychuan.vue'
import Chen from '@/views/ymc/Chen.vue'

export default [
    {
        // 分庄
        path: '/ymc',
        name: 'Ymc',
        component: Ymc
    },
    {
        // 颍川
        path: '/yingchuan',
        name: 'Ychuan',
        component: Ychuan
    },
    {
        // 陈氏
        path: '/chenshi',
        name: 'Chen',
        component: Chen
    }
]
